import React, { Component } from 'react';

// --- Dummy Data (Healthcare-Themed) ---
const popularTags = [
  { name: '#medicine', posts: '45,678', trending: true },
  { name: '#nursing', posts: '38,912', trending: false },
  { name: '#healthtech', posts: '52,134', trending: true },
  { name: '#mentalhealth', posts: '41,567', trending: false },
  { name: '#vaccines', posts: '49,823', trending: true },
  { name: '#telemedicine', posts: '55,291', trending: false },
];

const initialMeetups = []; // Start empty, populate live

class ForumLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchQuery: '',
      currentFilter: 'newest', // Added: default filter to 'newest'
      meetups: [...initialMeetups], // Start empty, populate live
      showAllMeetups: false, // New: to control showing all meetups or just 5
      posts: [
        {
          id: 1,
          title: "Best practices for telemedicine in rural healthcare",
          author: { name: "Dr. Elena Vasquez", date: "3" },
          views: "542,891",
          commentCount: 78, // Updated: initial comment count
          likeCount: 234, // Added: initial like count
          imageBgColor: "#2e7d32", // Green for health theme
          image: null, // Added for image upload
          tags: ['telemedicine', 'ruralhealth', 'healthtech'],
          price: null,
          liked: false,
          showCommentInput: false,
          commentText: '',
          commentImage: null, // New: for image upload
          comments: [], // Array of comment objects: { id, text, author, date, parentId, showReplyInput, replyText, image }
          showReportMenu: false, // Added for report menu toggle
          showShareMenu: false, // Added for share menu toggle
        },
        {
          id: 2,
          title: "The impact of mental health awareness on patient outcomes.",
          author: { name: "Vignesh", date: "5" },
          views: "389,456",
          commentCount: 156, // Updated: initial comment count
          likeCount: 189, // Added: initial like count
          imageBgColor: "#1976d2", // Blue for charts
          image: null, // Added for image upload
          tags: ['mentalhealth', 'patientcare', 'awareness'],
          price: null,
          liked: false,
          showCommentInput: false,
          commentText: '',
          commentImage: null,
          comments: [],
          showReportMenu: false, // Added
          showShareMenu: false, // Added
        },
        {
          id: 3,
          title: "OneHealth - Medical Records App - Download from mediapp.com",
          author: { name: "Dr. Mansurul Haque", date: "2" },
          views: "678,234",
          commentCount: 203, // Updated: initial comment count
          likeCount: 456, // Added: initial like count
          imageBgColor: "#388e3c", // Green for app
          image: null, // Added for image upload
          tags: ['medicalrecords', 'healthapp', 'ehr'],
          price: null,
          liked: false,
          showCommentInput: false,
          commentText: '',
          commentImage: null,
          comments: [],
          showReportMenu: false, // Added
          showShareMenu: false, // Added
        },
      ],
      newPostTitle: '',
      newPostTags: '',
      newPostImage: null, // Added for new post image
      showLoadMore: true,
    };
  }

  componentDidMount() {
    // Add initial live meetups on mount
    this.addInitialMeetups();
    // Simulate live updates for meetups every 10 seconds
    this.liveUpdateInterval = setInterval(() => {
      this.addNewMeetup();
    }, 10000); // 10 seconds for demo; adjust as needed
  }

  componentWillUnmount() {
    // Clean up the intervals
    if (this.liveUpdateInterval) {
      clearInterval(this.liveUpdateInterval);
    }
  }

  addInitialMeetups = () => {
    const initialEvents = [
      {
        date: new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric' }).toUpperCase(),
        title: 'AMA Annual Conference - Advancing Medicine...',
        location: 'American Medical Association • Chicago, IL'
      },
      {
        date: new Date(Date.now() + 86400000).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }).toUpperCase(), // Tomorrow
        title: 'Nursing Leadership Summit | ANA',
        location: 'American Nurses Association • New York, NY'
      },
      {
        date: new Date(Date.now() + 2 * 86400000).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }).toUpperCase(), // Day after
        title: 'HealthTech Innovation Expo - HIMSS',
        location: 'HIMSS • Orlando, FL'
      },
    ];
    this.setState({ meetups: initialEvents });
  };

  addNewMeetup = () => {
    // Simulate adding varied new meetups (e.g., webinars, conferences, virtual events)
    const meetupTitles = [
      'Live Webinar: Advances in AI for Healthcare Diagnostics',
      'Virtual Panel: Telemedicine Trends in 2023',
      'Online Workshop: Mental Health Strategies for Clinicians',
      'Webinar: Vaccine Development and Distribution',
      'Live Discussion: EHR Systems and Patient Privacy'
    ];
    const locations = [
      'Virtual Event • Hosted by HealthTech Institute',
      'Online • Sponsored by MedEd Foundation',
      'Webinar • Global Health Network',
      'Virtual Conference • Healthcare Innovators',
      'Live Stream • Nursing Association'
    ];
    const randomTitle = meetupTitles[Math.floor(Math.random() * meetupTitles.length)];
    const randomLocation = locations[Math.floor(Math.random() * locations.length)];
    const newMeetup = {
      date: new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric' }).toUpperCase(),
      title: randomTitle,
      location: randomLocation,
    };
    this.setState(prevState => ({
      meetups: [newMeetup, ...prevState.meetups], // Add to the top for visibility
    }));
  };

  setCurrentFilter = (filter) => { // Added: method to set current filter
    this.setState({ currentFilter: filter });
  };

  handleSearch = (e) => {
    this.setState({ searchQuery: e.target.value });
  };

  handleCreatePost = () => {
    const { newPostTitle, newPostTags, newPostImage, posts } = this.state;
    if (!newPostTitle.trim()) {
      alert('Please enter a post title.');
      return;
    }
    const newPost = {
      id: posts.length + 1,
      title: newPostTitle,
      author: { name: "You", date: "0" }, // Date set to "0" for "0 days ago" (as per your request to keep it like that)
      views: "0",
      commentCount: 0, // Added: initial comment count for new posts
      likeCount: 0, // Added: initial like count for new posts
      imageBgColor: "#4caf50", // Default green
      image: newPostImage, // Include uploaded image
      tags: newPostTags.split(',').map(tag => tag.trim()).filter(tag => tag),
      price: null,
      liked: false,
      showCommentInput: false,
      commentText: '',
      commentImage: null,
      comments: [],
      showReportMenu: false, // Added
      showShareMenu: false, // Added
    };
    this.setState({
      posts: [newPost, ...posts], // New post is added to the top and shows immediately on the page
      newPostTitle: '',
      newPostTags: '',
      newPostImage: null, // Reset image
    });
  };

  handleNewPostImageChange = (file) => {
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.setState({ newPostImage: e.target.result });
      };
      reader.readAsDataURL(file);
    }
  };

  handleLike = (postId) => {
    this.setState(prevState => ({
      posts: prevState.posts.map(post =>
        post.id === postId ? { 
          ...post, 
          liked: !post.liked,
          likeCount: post.liked ? post.likeCount - 1 : post.likeCount + 1 // Updated: increment/decrement like count
        } : post
      ),
    }));
  };

  handleToggleShareMenu = (postId) => {
    this.setState(prevState => ({
      posts: prevState.posts.map(post =>
        post.id === postId ? { ...post, showShareMenu: !post.showShareMenu } : post
      ),
    }));
  };

  handleCopyLink = (postId) => {
    const link = `https://example.com/post/${postId}`; // Dummy link
    navigator.clipboard.writeText(link).then(() => {
      alert('Link copied to clipboard!');
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
    // Close the menu after copying
    this.setState(prevState => ({
      posts: prevState.posts.map(post =>
        post.id === postId ? { ...post, showShareMenu: false } : post
      ),
    }));
  };

  handleToggleReportMenu = (postId) => {
    this.setState(prevState => ({
      posts: prevState.posts.map(post =>
        post.id === postId ? { ...post, showReportMenu: !post.showReportMenu } : post
      ),
    }));
  };

  handleReport = (postId) => {
    alert('Post reported.');
    // Close the menu after reporting
    this.setState(prevState => ({
      posts: prevState.posts.map(post =>
        post.id === postId ? { ...post, showReportMenu: false } : post
      ),
    }));
  };

  handleToggleCommentInput = (postId) => {
    this.setState(prevState => ({
      posts: prevState.posts.map(post =>
        post.id === postId ? { ...post, showCommentInput: !post.showCommentInput } : post
      ),
    }));
  };

  handleCommentChange = (postId, text) => {
    this.setState(prevState => ({
      posts: prevState.posts.map(post =>
        post.id === postId ? { ...post, commentText: text } : post
      ),
    }));
  };

  handleCommentImageChange = (postId, file) => {
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.setState(prevState => ({
          posts: prevState.posts.map(post =>
            post.id === postId ? { ...post, commentImage: e.target.result } : post
          ),
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  handleReplyImageChange = (postId, commentId, file) => {
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.setState(prevState => ({
          posts: prevState.posts.map(post =>
            post.id === postId ? {
              ...post,
              comments: post.comments.map(c =>
                c.id === commentId ? { ...c, replyImage: e.target.result } : c
              ),
            } : post
          ),
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  handleAddComment = (postId) => {
    const post = this.state.posts.find(p => p.id === postId);
    if (!post.commentText.trim() && !post.commentImage) return;
    const newComment = {
      id: Date.now(),
      text: post.commentText,
      author: 'You',
      date: 'now',
      parentId: null,
      showReplyInput: false,
      replyText: '',
      replyImage: null,
      image: post.commentImage, // Include image
    };
    this.setState(prevState => ({
      posts: prevState.posts.map(p =>
        p.id === postId ? {
          ...p,
          comments: [...p.comments, newComment],
          commentText: '',
          commentImage: null,
          commentCount: p.commentCount + 1, // Updated: increment comment count
        } : p
      ),
    }));
  };

  handleToggleReplyInput = (postId, commentId) => {
    this.setState(prevState => ({
      posts: prevState.posts.map(post =>
        post.id === postId ? {
          ...post,
          comments: post.comments.map(c =>
            c.id === commentId ? { ...c, showReplyInput: !c.showReplyInput } : c
          ),
        } : post
      ),
    }));
  };

  handleReplyChange = (postId, commentId, text) => {
    this.setState(prevState => ({
      posts: prevState.posts.map(post =>
        post.id === postId ? {
          ...post,
          comments: post.comments.map(c =>
            c.id === commentId ? { ...c, replyText: text } : c
          ),
        } : post
      ),
    }));
  };

  handleAddReply = (postId, commentId) => {
    const post = this.state.posts.find(p => p.id === postId);
    const comment = post.comments.find(c => c.id === commentId);
    if (!comment.replyText.trim() && !comment.replyImage) return;
    const newReply = {
      id: Date.now(),
      text: comment.replyText,
      author: 'You',
      date: 'now',
      parentId: commentId,
      showReplyInput: false,
      replyText: '',
      replyImage: null,
      image: comment.replyImage, // Include image
    };
    this.setState(prevState => ({
      posts: prevState.posts.map(p =>
        p.id === postId ? {
          ...p,
          comments: [...p.comments, newReply].map(c =>
            c.id === commentId ? { ...c, replyText: '', replyImage: null, showReplyInput: false } : c
          ),
          commentCount: p.commentCount + 1, // Updated: increment comment count for replies
        } : p
      ),
    }));
  };

  handleLoadMore = () => {
    // Simulate loading more posts
    const newPosts = [
      {
        id: this.state.posts.length + 1,
        title: "Vaccination strategies during pandemics.",
        author: { name: "Dr. New Author", date: "1" },
        views: "123,456",
        commentCount: 45, // Updated: initial comment count for loaded posts
        likeCount: 78, // Added: initial like count for loaded posts
        imageBgColor: "#2196f3",
        image: null, // Added for image upload
        tags: ['vaccines', 'pandemic', 'publichealth'],
        price: null,
        liked: false,
        showCommentInput: false,
        commentText: '',
        commentImage: null,
        comments: [],
        showReportMenu: false, // Added
        showShareMenu: false, // Added
      },
    ];
    this.setState(prevState => ({
      posts: [...prevState.posts, ...newPosts],
      showLoadMore: false, // Hide after loading
    }));
  };

  renderComment = (postId, comment) => {
    const post = this.state.posts.find(p => p.id === postId);
    const replies = post.comments.filter(c => c.parentId === comment.id);
    const indent = comment.parentId ? '20px' : '0';
    return (
      <div key={comment.id} className="comment" style={{ marginLeft: indent, marginBottom: '10px' }}>
        <p style={{ margin: 0, fontSize: '14px' }}>
          <strong>{comment.author}</strong> {comment.date}: {comment.text}
        </p>
        {comment.image && <img src={comment.image} alt="Comment" className="comment-image" />}
        <button
          className="forum-reply-btn"
          onClick={() => this.handleToggleReplyInput(postId, comment.id)}
        >
          Reply
        </button>
        {comment.showReplyInput && (
          <div className="reply-input-section">
            <input
              type="text"
              placeholder="Add a reply..."
              value={comment.replyText}
              onChange={(e) => this.handleReplyChange(postId, comment.id, e.target.value)}
            />
            <button
              className="forum-image-upload-btn"
              onClick={() => document.getElementById(`reply-file-${comment.id}`).click()}
            >
              📎
            </button>
            <input
              id={`reply-file-${comment.id}`}
              type="file"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={(e) => this.handleReplyImageChange(postId, comment.id, e.target.files[0])}
            />
            <button onClick={() => this.handleAddReply(postId, comment.id)}>Post Reply</button>
          </div>
        )}
        {replies.map(reply => this.renderComment(postId, reply))}
      </div>
    );
  };

  renderHeader() {
    return (
      <header className="forum-header">
        <div className="forum-header__left">
          <button className="forum-header__logo">
           <a className="navbar-brand klinic-logo" href="/home">
                                    <img src={require("../assets/images/logo.png")} alt="Sahyatri-Matrimony-Logo" className='nav-logo' />
                                </a>
          </button>
        </div>
        <div className="forum-header__center">
          <div className="forum-header__search-bar">
            <input
              type="text"
              placeholder="Search healthcare topics..."
              value={this.state.searchQuery}
              onChange={this.handleSearch}
            />
          </div>
        </div>
        <div className="forum-header__right">
          <button className="forum-header__action-btn">⚙️</button>
          <button className="forum-header__action-btn">🔔</button>
                   <div className="forum-header__user-profile">
            Vignesh
            <div style={{ width: 30, height: 30, borderRadius: '50%', backgroundColor: '#4caf50', marginLeft: 10 }}></div>
          </div>
        </div>
      </header>
    );
  }

  renderSidebarLeft() {
    return (
      <div className="forum-sidebar forum-sidebar--left">
        <section className="forum-sidebar__section forum-sidebar__section--recent">
          <h3>Newest and Recent</h3>
          <p className="forum-subtext">Posts and health updates</p>
          <ul>
            <li className={this.state.currentFilter === 'newest' ? 'active' : ''} onClick={() => this.setCurrentFilter('newest')}><span className="forum-icon">💡</span> Newest and Recent</li>
            <li className={this.state.currentFilter === 'popular' ? 'active' : ''} onClick={() => this.setCurrentFilter('popular')}><span className="forum-icon">🏆</span> Popular of the day</li>
            <li className={this.state.currentFilter === 'following' ? 'active' : ''} onClick={() => this.setCurrentFilter('following')}><span className="forum-icon">🔥</span> Following <span className="forum-count">24</span></li>
          </ul>
        </section>

        <section className="forum-sidebar__section">
          <h3>Popular Tags</h3>
          <ul>
            {popularTags.map((tag, index) => (
              <li key={index}>
                <span className="forum-tag-icon">#</span>
                <span className="forum-tag-name">{tag.name}</span>
                {tag.trending && <span className="forum-trending-label"> • Trending</span>}
                <span className="forum-tag-posts">{tag.posts} Posted by this tag</span>
              </li>
            ))}
          </ul>
        </section>

        <section className="forum-sidebar__section">
          <h3>Pinned Group</h3>
          <ul>
            <li><span className="forum-tag-icon">#</span>medicine</li>
            <li><span className="forum-tag-icon">#</span>nursing</li>
            <li><span className="forum-tag-icon">#</span>healthtech</li>
          </ul>
        </section>
      </div>
    );
  }

  renderPostCard(post) {
    const topLevelComments = post.comments.filter(c => c.parentId === null);
    return (
      <article className="forum-post-card">
        <div className="forum-post-card__content">
          <div className="forum-post-card__image-container" style={{ backgroundColor: post.image ? 'transparent' : post.imageBgColor }}>
            {post.image ? (
              <img src={post.image} alt="Post" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }} />
            ) : null}
            {post.price && <div className="forum-post-card__price">{post.price}</div>}
          </div>
          <div className="forum-post-card__details">
            <h2 className="forum-post-card__title">{post.title}</h2>
            <div className="forum-post-card__tags">
              {post.tags.map((tag, index) => (
                <span key={index} className="forum-tag">{tag}</span>
              ))}
            </div>
            <div className="forum-post-card__meta">
              <span className="forum-author">{post.author.name} •</span>
              <span className="forum-date">{post.author.date} days ago •</span>
              <span className="forum-views">{post.views} Views •</span>
              <span className="forum-comments">{post.commentCount} Comments</span>
            </div>
          </div>
        </div>
        <div className="forum-post-card__bottom">
          <div className="forum-post-card__actions">
            <button
              className={`forum-action-button ${post.liked ? 'liked' : ''}`}
              onClick={() => this.handleLike(post.id)}
            >
              {post.liked ? '❤️' : '🤍'} {post.likeCount}
            </button>
            <button className="forum-action-button" onClick={() => this.handleToggleCommentInput(post.id)}>
              <i className="fa-regular fa-comment"></i> {post.commentCount}
            </button>
            <button className="forum-action-button" onClick={() => this.handleToggleShareMenu(post.id)}>
              <i className="fa-solid fa-share"></i>
            </button>
            <button className="forum-action-button" onClick={() => this.handleToggleReportMenu(post.id)}>
              ...
            </button>
          </div>
          {post.showShareMenu && (
            <div className="forum-share-menu">
              <button onClick={() => this.handleCopyLink(post.id)}>Copy Link</button>
            </div>
          )}
          {post.showReportMenu && (
            <div className="forum-report-menu">
              <button onClick={() => this.handleReport(post.id)}>Report</button>
            </div>
          )}
          {post.showCommentInput && (
            <div className="forum-comments-section">
              {topLevelComments.map(comment => this.renderComment(post.id, comment))}
              <div className="forum-comment-input">
                <input
                  type="text"
                  placeholder="Add a comment..."
                  value={post.commentText}
                  onChange={(e) => this.handleCommentChange(post.id, e.target.value)}
                />
                <button
                  className="forum-image-upload-btn"
                  onClick={() => document.getElementById(`comment-file-${post.id}`).click()}
                >
                  📎
                </button>
                <input
                  id={`comment-file-${post.id}`}
                  type="file"
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={(e) => this.handleCommentImageChange(post.id, e.target.files[0])}
                />
                <button onClick={() => this.handleAddComment(post.id)}>Post Comment</button>
              </div>
            </div>
          )}
        </div>
      </article>
    );
  }

  renderMainContent() {
    let filteredPosts = this.state.posts.filter(post =>
      post.title.toLowerCase().includes(this.state.searchQuery.toLowerCase()) ||
      post.author.name.toLowerCase().includes(this.state.searchQuery.toLowerCase()) ||
      post.tags.some(tag => tag.toLowerCase().includes(this.state.searchQuery.toLowerCase()))
    );

    // Sort based on currentFilter
    if (this.state.currentFilter === 'newest') {
      filteredPosts = filteredPosts.sort((a, b) => parseInt(a.author.date) - parseInt(b.author.date));
    } else if (this.state.currentFilter === 'popular') {
      filteredPosts = filteredPosts.sort((a, b) => parseInt(b.views.replace(/,/g, '')) - parseInt(a.views.replace(/,/g, '')));
    } else if (this.state.currentFilter === 'following') {
      // Assuming following shows all for now, or you can add logic to filter by following
      filteredPosts = filteredPosts; // No specific sorting, or add custom logic
    }

    return (
      <main className="forum-main-content">
        <div className="forum-create-post-bar">
          <div className="forum-user-avatar-small"></div>
          <input
            type="text"
            placeholder="Share healthcare insights..."
            value={this.state.newPostTitle}
            onChange={(e) => this.setState({ newPostTitle: e.target.value })}
          />
          <input
            type="text"
            placeholder="Tags (comma-separated)"
            value={this.state.newPostTags}
            onChange={(e) => this.setState({ newPostTags: e.target.value })}
            style={{ marginLeft: 10, flexGrow: 0.5 }}
          />
          <button
            className="forum-image-upload-btn"
            onClick={() => document.getElementById('new-post-file').click()}
          >
            +
          </button>
          <input
            id="new-post-file"
            type="file"
            accept="image/*"
            style={{ display: 'none' }}
            onChange={(e) => this.handleNewPostImageChange(e.target.files[0])}
          />
          <button className="forum-create-post-btn" onClick={this.handleCreatePost}>Create Post</button>
        </div>

        {filteredPosts.map(post => this.renderPostCard(post))}

        {this.state.showLoadMore && (
          <button className="forum-load-more-btn" onClick={this.handleLoadMore}>Load More Posts</button>
        )}
      </main>
    );
  }

  renderSidebarRight() {
    const displayedMeetups = this.state.showAllMeetups ? this.state.meetups : this.state.meetups.slice(0, 5);
    return (
      <div className="forum-sidebar forum-sidebar--right">
        <section className="forum-sidebar__section forum-sidebar__section--meetups">
          <h3>Meetups</h3>
          <ul>
            {displayedMeetups.map((meetup, index) => (
              <li key={index} className="forum-meetup-item">
                <span className="forum-meetup-date">{meetup.date}</span>
                <div className="forum-meetup-details">
                  <p className="forum-meetup-title">{meetup.title}</p>
                  <p className="forum-meetup-location">{meetup.location}</p>
                </div>
              </li>
            ))}
          </ul>
          {this.state.meetups.length > 5 && !this.state.showAllMeetups && (
            <button className="forum-read-more-btn" onClick={() => this.setState({ showAllMeetups: true })}>
              Read More
            </button>
          )}
          {this.state.showAllMeetups && (
            <button className="forum-show-less-btn" onClick={() => this.setState({ showAllMeetups: false })}>
              Show Less
            </button>
          )}
        </section>
      </div>
    );
  }

  render() {
    return (
      <div className="forum-container">
        {this.renderHeader()}
        <div className="forum-main-content-wrapper">
          {this.renderSidebarLeft()}
          {this.renderMainContent()}
          {this.renderSidebarRight()}
        </div>
      </div>
    );
  }
}

export default ForumLayout;